import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "..";

const selectDataTopics = (state: RootState) => state.examBuilder.main.examData;

export const selectObjectiveIDs = createSelector([selectDataTopics], (dataTopics) => {
  if (!dataTopics || !dataTopics.objectives) {
    return [];
  }
  return Object.keys(dataTopics.objectives);
});
